module.exports = __webpack_public_path__ + "static/og-image-fac9f8460609312dfb72ead068118c31.png";